@if (!hideForLoggedInUsersChange()) {
    <div
        [ngClass]="[getBackgroundClass(), getBannerSizeClass(), getBannerTextAlignmentClass()]"
        [ngStyle]="{ '--home-skinny-cta-fg': foregroundColorHex }"
        class="home-skinny-cta">
        <div class="home-skinny-cta__inner container">
            @if (block.data.text) {
                <!-- Contains text from WYSIWYG editor and 'could' contain an anchor. -->
                <span
                    class="home-skinny-cta__text-wrapper"
                    [ngClass]="{ 'home-skinny-cta__text-wrapper--inline': block.data?.linkAndTextInline }">
                    @if (block.data.showInfoIcon) {
                        <svg
                            aria-hidden="true"
                            class="home-skinny-cta__info-icon"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                                stroke="var(--color-secondary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    }
                    <span [innerHtml]="block.data.text"></span>
                </span>
            }
            <!-- Contains link text and/or external link icon. This option will display the link beneath the WYSIWYG editor text. -->
            @if (block.data.linkUrl) {
                @if (block.data.externalLink) {
                    <div class="d-flex">
                        <a [href]="block.data.linkUrl" class="home-skinny-cta__anchor" target="_blank">
                            {{ block.data.linkText }}
                            <svg
                                class="ms-2"
                                height="24"
                                viewBox="0 0 26 24"
                                width="26"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.6602 7H6.3923C5.22856 7 4.28516 7.89543 4.28516 9V18C4.28516 19.1046 5.22856 20 6.3923 20H15.8744C17.0382 20 17.9816 19.1046 17.9816 18V13"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2" />
                                <path
                                    d="M10.6055 14L21.1412 4"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2" />
                                <path
                                    d="M15.875 4H21.1429V9"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2" />
                            </svg>
                        </a>
                    </div>
                } @else {
                    <a
                        [href]="block.data.linkUrl"
                        [innerText]="block.data.linkText"
                        class="home-skinny-cta__anchor"></a>
                }
            }
        </div>
    </div>
}
